import dynamic from "next/dynamic"
import { getCookie } from "cookies-next"
import { useGlobalState } from "providers/globalState"

const layouts = {
    original: dynamic(() => import("components/layouts/original/layoutOriginal")),
    tct2025: dynamic(() => import("components/layouts/tct2025/layoutTct2025")),
    tct2026: dynamic(() => import("components/layouts/tct2026/layoutTct2026")),
    latam2026: dynamic(() => import("components/layouts/latam2026/layoutLatam2026")),
    app: dynamic(() => import("components/layouts/app/appLayout")),
}

export default function Layout({ layout, layoutVariant, ...rest }) {
    const { site } = useGlobalState()

    // Use prop from server if available (eliminates hydration mismatch)
    // Fall back to cookie for pages not using runMiddleware
    const variant = layoutVariant !== undefined ? layoutVariant : getCookie("layout") || null

    // a layout passed as a prop takes precedent over any global setting
    const resolvedLayout = layout || rest.site?.theme?.layout || "original"

    const Component = layouts[resolvedLayout]

    return (
        <>
            {/*<link rel="stylesheet" href={`/styles/meetings/${locale}.css`} />*/}
            <Component socialFooterText={site.meeting?.socialFooterText} {...rest} layoutVariant={variant} />
        </>
    )
}
